/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { GraphicalTakeOffPictureDto } from './dto';

export const GraphicalTakeOffPictureMapper = entity<GraphicalTakeOffPictureDto>();
